exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ":host .dashboard-page .container {\n  min-height: calc(100% - 200px); }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/app/components/dashboard/dashboard-page.component.scss
// module id = 171
// module chunks = 0